import { ActionIdType } from 'src/editor/shared/types/automation-rules/actions-types'
import { TriggerKeyType } from 'src/editor/shared/types/automation-rules/triggers-types'
import { EntityIdType } from 'src/shared/schemas/entity-id.schema'
import {
  AutomationRuleInterface,
  AutomationRulesState,
} from './automationRulesReducer'

export const getAutomationRules = (state: AutomationRulesState) => {
  return state.automationRules
}

export const getMaxAutomationActionId = (state: AutomationRulesState) => {
  return state.automationRules.reduce((maxId, rule) => {
    return Math.max(
      maxId,
      rule.automationActions.reduce((maxActionId, action) => {
        return Math.max(maxActionId, action.id)
      }, 0),
    )
  }, 0)
}

export const getAutomationRuleByEntityId =
  (entityId: EntityIdType, triggerKey: TriggerKeyType) =>
  (state: AutomationRulesState) => {
    return state.automationRules.find(
      (automationRule: AutomationRuleInterface) =>
        automationRule.automationTrigger[triggerKey] === entityId,
    )
  }

export const getAutomationRuleActionsByEntityId =
  (entityId: EntityIdType, triggerKey: TriggerKeyType) =>
  (state: AutomationRulesState) => {
    return (
      getAutomationRuleByEntityId(entityId, triggerKey)(state)
        ?.automationActions || []
    )
  }

export const getAutomationRuleActionByEntityId =
  (
    entityId: EntityIdType,
    triggerKey: TriggerKeyType,
    actionId?: ActionIdType,
  ) =>
  (state: AutomationRulesState) => {
    const rule = getAutomationRuleActionsByEntityId(entityId, triggerKey)(state)
    return rule.find(action => action.id === actionId)
  }

const automationRulesSelectors = {
  getAutomationRules,
  getMaxAutomationActionId,
  getAutomationRuleByEntityId,
  getAutomationRuleActionsByEntityId,
  getAutomationRuleActionByEntityId,
}

export default automationRulesSelectors
